<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="商户">
                  <GridSelectShop
                      style="width: 200px"
                      title="选择所属店铺"
                      labelName="storeName"
                      labelValue="id"
                      :value="queryForm.storeId"
                      :limit="1"
                      size="small"
                      @getValue="getSearchValueShopId"
                      :columns="STORE_code"
                      :searchs="STORE_search"
                      dataListUrl="/shop/store/findList"
                      entityBeanName="shopStore"
                      queryEntityUrl="/shop/store/get"
                  >
                  </GridSelectShop>
              </el-form-item>
              <el-form-item label="订单编号">
                  <el-input style="width: 200px" v-model="queryForm.orderNumber"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getShopStorePayapiOrderList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
<!--        <el-button-->
<!--          type="primary"-->
<!--          size="small"-->
<!--          icon="el-icon-plus"-->
<!--          @click="addShopStorePayapiOrder"-->
<!--        >新建</el-button>-->
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editShopStorePayapiOrder(null)"-->
<!--        >修改</el-button>-->
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteShopStorePayapiOrder(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshShopStorePayapiOrderList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="shopStorePayapiOrderList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="storeId"
        label="商户"
        width="180"
      >
          <template slot-scope="scop">
            <div v-if="scop.row.store">
              {{ scop.row.store.storeName }}
            </div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderNumber"
        label="订单编号"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderMoney"
        label="订单金额"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="extraData"
        label="用户自定义数据"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="notifyUrl"
        label="调回URL"
        width="180"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="timeStamp"-->
<!--        label=""-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="isSuccess"
        label="是否回调成功"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="callbackTimes"
        label="回调次数"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="nextCallbackTime"
        label="下一次回调时间"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
              <el-button v-if="scop.row.isSuccess != 1" type="primary" round size="mini" @click="onCallBack(scop.row.orderNumber)">回调</el-button>
              <div @click="checkShopStorePayapiOrder(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
<!--            <div @click="editShopStorePayapiOrder(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
            <div @click="deleteShopStorePayapiOrder(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="shopStorePayapiOrderStates[shopStorePayapiOrderState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="shopStorePayapiOrder"
          ref="shopStorePayapiOrderForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="商户"
            prop="storeId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopStorePayapiOrder.storeId"-->
<!--              :disabled="shopStorePayapiOrderState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectShop
                  style="width: 200px"
                  title="选择所属店铺"
                  labelName="storeName"
                  labelValue="id"
                  :value="shopStorePayapiOrder.storeId"
                  :disabled="shopStorePayapiOrderState == 'check'"
                  :limit="1"
                  size="small"
                  @getValue="getValueShopId"
                  :columns="STORE_code"
                  :searchs="STORE_search"
                  dataListUrl="/shop/store/findList"
                  entityBeanName="shopStore"
                  queryEntityUrl="/shop/store/get"
              >
              </GridSelectShop>
          </el-form-item>
          <el-form-item
            label="订单编号"
            prop="orderNumber"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStorePayapiOrder.orderNumber"
              :disabled="shopStorePayapiOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="订单金额"
            prop="orderMoney"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStorePayapiOrder.orderMoney"
              :disabled="shopStorePayapiOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="用户自定义数据"
            prop="extraData"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStorePayapiOrder.extraData"
              :disabled="shopStorePayapiOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="调回URL"
            prop="notifyUrl"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStorePayapiOrder.notifyUrl"
              :disabled="shopStorePayapiOrderState == 'check'"
            ></el-input>
          </el-form-item>
<!--          <el-form-item-->
<!--            label=""-->
<!--            prop="timeStamp"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopStorePayapiOrder.timeStamp"-->
<!--              :disabled="shopStorePayapiOrderState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="是否回调成功"
            prop="isSuccess"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStorePayapiOrder.isSuccess"
              :disabled="shopStorePayapiOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="回掉次数"
            prop="callbackTimes"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStorePayapiOrder.callbackTimes"
              :disabled="shopStorePayapiOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="下一次回调时间"
            prop="nextCallbackTime"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStorePayapiOrder.nextCallbackTime"
              :disabled="shopStorePayapiOrderState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="shopStorePayapiOrderState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectShop from '@/components/gridselect/gidselect.vue';
import { STORE, STORE_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectShop,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopStorePayapiOrderList();
                    this.getShopStorePayapiOrderList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopStorePayapiOrderList();
                    this.getShopStorePayapiOrderList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                STORE_code: STORE,
                STORE_search: STORE_SEARCH,
                queryForm:{
                     storeId: '', //商户ID
                     orderNumber: '', //订单编号
                     orderMoney: '', //订单金额
                     extraData: '', //用户自定义数据
                     notifyUrl: '', //调回URL
                     timeStamp: '', //
                     isSuccess: '', //是否回调成功
                     callbackTimes: '', //回掉次数
                     nextCallbackTime: '', //下一次回调时间
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopStorePayapiOrderState: 'add',
                shopStorePayapiOrderStates: {
                    add: '新建接口订单',
                    check: '查看接口订单',
                    edit: '修改接口订单'
                },

                multipleSelection: [],
                shopStorePayapiOrderList: [],
                shopStorePayapiOrder: {
                    id: '', //
                    storeId: '', //商户ID
                    orderNumber: '', //订单编号
                    orderMoney: '', //订单金额
                    extraData: '', //用户自定义数据
                    notifyUrl: '', //调回URL
                    timeStamp: '', //
                    isSuccess: '', //是否回调成功
                    callbackTimes: '', //回掉次数
                    nextCallbackTime: '', //下一次回调时间
                },
                btnLoading: false,
                fullscreenLoading: false,

                rules: {
                    storeId: [{ required: true, message: '商户ID不能为空', trigger: 'blur' }],
                    orderNumber: [{ required: true, message: '订单编号不能为空', trigger: 'blur' }],
                    orderMoney: [{ required: true, message: '订单金额不能为空', trigger: 'blur' }],
                    extraData: [{ required: true, message: '用户自定义数据不能为空', trigger: 'blur' }],
                    notifyUrl: [{ required: true, message: '调回URL不能为空', trigger: 'blur' }],
                    timeStamp: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    isSuccess: [{ required: true, message: '是否回调成功不能为空', trigger: 'blur' }],
                    callbackTimes: [{ required: true, message: '回掉次数不能为空', trigger: 'blur' }],
                    nextCallbackTime: [{ required: true, message: '下一次回调时间不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getShopStorePayapiOrderList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetShopStorePayapiOrderList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopStorePayapiOrderList = [];
            },
            resetDialog() {
                this.shopStorePayapiOrderState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      storeId: '', //商户ID
                      orderNumber: '', //订单编号
                      orderMoney: '', //订单金额
                      extraData: '', //用户自定义数据
                      notifyUrl: '', //调回URL
                      timeStamp: '', //
                      isSuccess: '', //是否回调成功
                      callbackTimes: '', //回掉次数
                      nextCallbackTime: '', //下一次回调时间
                };
                this.getShopStorePayapiOrderList();
            },
            closeDialog() {
                this.showDialog = false
                this.shopStorePayapiOrder = {
                      id: '', //
                      storeId: '', //商户ID
                      orderNumber: '', //订单编号
                      orderMoney: '', //订单金额
                      extraData: '', //用户自定义数据
                      notifyUrl: '', //调回URL
                      timeStamp: '', //
                      isSuccess: '', //是否回调成功
                      callbackTimes: '', //回掉次数
                      nextCallbackTime: '', //下一次回调时间
                };
            },
            getSearchValueShopId(val){
                this.queryForm.storeId = val
            },
            getValueShopId(val){
                this.shopStorePayapiOrder.storeId = val
            },
            submitForm() {
                if (this.shopStorePayapiOrderState == 'add') {
                    this.$refs.shopStorePayapiOrderForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/storepayapiorder/add`,{ ...this.shopStorePayapiOrder }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopStorePayapiOrderList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopStorePayapiOrderState == 'edit') {
                    this.$refs.shopStorePayapiOrderForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.shopStorePayapiOrder.store
                            post(`/shop/storepayapiorder/edit`,{ ...this.shopStorePayapiOrder }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopStorePayapiOrderList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addShopStorePayapiOrder() {
                this.showDialog = true;
                this.shopStorePayapiOrderState = 'add';
            },
            checkShopStorePayapiOrder(shopStorePayapiOrderId) {
                console.log(shopStorePayapiOrderId);
                this.currentShopStorePayapiOrderId = shopStorePayapiOrderId;

                this.getShopStorePayapiOrderById();
                this.showDialog = true;
                this.shopStorePayapiOrderState = 'check';
            },
            editShopStorePayapiOrder(shopStorePayapiOrderId) {
                console.log('shopStorePayapiOrder', shopStorePayapiOrderId);
                if (shopStorePayapiOrderId) {
                    this.currentShopStorePayapiOrderId = shopStorePayapiOrderId;
                    this.getShopStorePayapiOrderById();
                } else {
                    this.shopStorePayapiOrder = { ...this.shopStorePayapiOrder, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopStorePayapiOrderState = 'edit';
            },
            deleteShopStorePayapiOrder(shopStorePayapiOrderId) {
                let ids = '';
                if (shopStorePayapiOrderId) {
                    ids = shopStorePayapiOrderId;
                } else {
                    ids = this.multipleSelection.map((shopStorePayapiOrder) => shopStorePayapiOrder.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/shop/storepayapiorder/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopStorePayapiOrderList();
                                this.getShopStorePayapiOrderList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshShopStorePayapiOrderList() {
                this.resetShopStorePayapiOrderList();
                this.getShopStorePayapiOrderList();
            },
            getShopStorePayapiOrderList(query = {}) {
                this.loading = true;
                get(`/shop/storepayapiorder/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopStorePayapiOrderList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopStorePayapiOrderById() {
                get(`/shop/storepayapiorder/get`,{ id: this.currentShopStorePayapiOrderId }).then((res) =>{
                    if(res.success){
                      this.shopStorePayapiOrder = { ...this.shopStorePayapiOrder, ...res.shopStorePayapiOrder };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopStorePayapiOrderList() {
                //this.btnLoading = true;
                exprotExcel(`/shop/storepayapiorder/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/shop/storepayapiorder/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/shop/storepayapiorder/importData`,formData);
              this.refreshShopStorePayapiOrderList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopStorePayapiOrderList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopStorePayapiOrderList();
            },
            onCallBack(orderNumber){
                this.$confirm('确认要进行手动回调吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.fullscreenLoading = true;
                    get('/payapi/ysepay/common/onCallback',{
                        orderNumber
                    }).then((res)=>{
                        this.$confirm(res.msg, '提示', {type:'warning',showCancelButton: false})
                        this.fullscreenLoading = false;
                    })

                }).catch(() => {
                });
            },
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>